"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcIdToken = exports.useOidcAccessToken = exports.useOidc = void 0;
const react_1 = require("react");
const oidc_1 = __importDefault(require("./vanilla/oidc"));
const defaultConfigurationName = "default";
const defaultIsAuthenticated = (getOidc, configurationName) => {
    let isAuthenticated = false;
    const oidc = getOidc(configurationName);
    if (oidc) {
        isAuthenticated = getOidc(configurationName).tokens != null;
    }
    return isAuthenticated;
};
const useOidc = (configurationName = defaultConfigurationName) => {
    const getOidc = oidc_1.default.get;
    const [isAuthenticated, setIsAuthenticated] = (0, react_1.useState)(defaultIsAuthenticated(getOidc, configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
        const newSubscriptionId = oidc.subscriveEvents((name, data) => {
            if (name === oidc_1.default.eventNames.logout_from_another_tab || name === oidc_1.default.eventNames.logout_from_same_tab || name === oidc_1.default.eventNames.token_aquired) {
                if (isMounted) {
                    setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName]);
    const login = (callbackPath = undefined, extras = null, silentLoginOnly = false) => {
        return getOidc(configurationName).loginAsync(callbackPath, extras, false, undefined, silentLoginOnly);
    };
    const logout = (callbackPath = undefined, extras = null) => {
        return getOidc(configurationName).logoutAsync(callbackPath, extras);
    };
    const renewTokens = (extras = null) => {
        return getOidc(configurationName).renewTokensAsync(extras);
    };
    return { login, logout, renewTokens, isAuthenticated };
};
exports.useOidc = useOidc;
const accessTokenInitialState = { accessToken: null, accessTokenPayload: null };
const initTokens = (configurationName) => {
    const getOidc = oidc_1.default.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return { accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload };
    }
    return accessTokenInitialState;
};
const useOidcAccessToken = (configurationName = defaultConfigurationName) => {
    const getOidc = oidc_1.default.get;
    const [state, setAccessToken] = (0, react_1.useState)(initTokens(configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setAccessToken({ accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload });
        }
        const newSubscriptionId = oidc.subscriveEvents((name, data) => {
            if (name == oidc_1.default.eventNames.token_renewed
                || name == oidc_1.default.eventNames.token_aquired
                || name === oidc_1.default.eventNames.logout_from_another_tab
                || name === oidc_1.default.eventNames.logout_from_same_tab) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setAccessToken(tokens != null ? { accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload } : accessTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName]);
    return state;
};
exports.useOidcAccessToken = useOidcAccessToken;
const idTokenInitialState = { idToken: null, idTokenPayload: null };
const initIdToken = (configurationName) => {
    const getOidc = oidc_1.default.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload };
    }
    return idTokenInitialState;
};
const useOidcIdToken = (configurationName = defaultConfigurationName) => {
    const getOidc = oidc_1.default.get;
    const [state, setIDToken] = (0, react_1.useState)(initIdToken(configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setIDToken({ idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload });
        }
        const newSubscriptionId = oidc.subscriveEvents((name, data) => {
            if (name == oidc_1.default.eventNames.token_renewed
                || name == oidc_1.default.eventNames.token_aquired
                || name === oidc_1.default.eventNames.logout_from_another_tab) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setIDToken(tokens != null ? { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload } : idTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName]);
    return state;
};
exports.useOidcIdToken = useOidcIdToken;
//# sourceMappingURL=ReactOidc.js.map